/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SearchCrownDescriptionGeometryDto } from '../../models/search-crown-description-geometry-dto';

export interface SearchForCrownDescriptionGeometry$Params {
  parish_or_township_code: string;
  parish_or_township_name: string;
  allotment?: string;
  section?: string;
  subdivision?: string;
  portion?: string;
  block?: string;
}

export function searchForCrownDescriptionGeometry(
  http: HttpClient,
  rootUrl: string,
  params: SearchForCrownDescriptionGeometry$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SearchCrownDescriptionGeometryDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    searchForCrownDescriptionGeometry.PATH,
    'get',
  );
  if (params) {
    rb.query('parish_or_township_code', params.parish_or_township_code, {});
    rb.query('parish_or_township_name', params.parish_or_township_name, {});
    rb.query('allotment', params.allotment, {});
    rb.query('section', params.section, {});
    rb.query('subdivision', params.subdivision, {});
    rb.query('portion', params.portion, {});
    rb.query('block', params.block, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SearchCrownDescriptionGeometryDto>;
      }),
    );
}

searchForCrownDescriptionGeometry.PATH = '/search/crown-description/geometry';
